import { StartupService } from '../services/startup.service';

export function startupServiceFactory(
    startupService: StartupService
): () => Promise<void> {
    return () => startupService.load();
}
